import React, { useState, useEffect } from "react";
import { useRouter } from "next/router";
import { useCurrentPage } from "../services/hooks/useCurrentPage";
import { usePathname } from "../services/hooks/usePathname";

export default React.memo(function Pagination({
  numPages,
  anchor,
  onPageChange,
  allowFunctionalControlOnly = false,
}) {
  const [currentPath, setCurrentPath] = useState();
  const router = useRouter();

  const { currentPage } = useCurrentPage();
  const { pathname } = usePathname();

  let pageLinks = [];

  useEffect(() => {
    let { query } = router;

    let { page } = query;

    if (Number(page)) {
      page = parseInt(page);
    } else {
      page = 1;
    }

    setCurrentPath(pathname);
  }, [router, pathname]);

  const handlePageItemClick = (page) => {
    return (e) => {
      e.preventDefault();

      if (typeof onPageChange === "function") {
        onPageChange(page);
      }

      if (allowFunctionalControlOnly) {
        return;
      }

      if (anchor) {
        router.replace(
          `${currentPath}?page=${page}#${anchor}`,
          `${currentPath}?page=${page}#${anchor}`,
          { scroll: false }
        );
      } else {
        router.replace(
          `${currentPath}?page=${page}`,
          `${currentPath}?page=${page}`,
          { scroll: false }
        );
      }
    };
  };

  if (numPages === 1 || !numPages) {
    return null;
  }

  if (numPages <= 6) {
    for (let i = 1; i <= numPages; i++) {
      pageLinks.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <a className="page-link" href="#" onClick={handlePageItemClick(i)}>
            {i}
          </a>
        </li>
      );
    }
  }

  if (numPages > 6) {
    if (currentPage <= 3) {
      for (let i = 1; i <= 3; i++) {
        pageLinks.push(
          <li
            key={i}
            className={`page-item ${currentPage === i ? "active" : ""}`}
          >
            <a className="page-link" href="#" onClick={handlePageItemClick(i)}>
              {i}
            </a>
          </li>
        );
      }

      pageLinks.push(
        <li key={"ellipsis-1"} className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            ∙∙∙
          </a>
        </li>
      );

      for (let i = numPages - 2; i <= numPages; i++) {
        pageLinks.push(
          <li key={i} className="page-item">
            <a className="page-link" href="#" onClick={handlePageItemClick(i)}>
              {i}
            </a>
          </li>
        );
      }
    } else if (currentPage > 3 && currentPage < numPages - 2) {
      pageLinks.push(
        <li key={1} className="page-item">
          <a className="page-link" href="#" onClick={handlePageItemClick(1)}>
            {1}
          </a>
        </li>
      );

      pageLinks.push(
        <li key={"ellipsis-1"} className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            ∙∙∙
          </a>
        </li>
      );

      pageLinks.push(
        <li key={currentPage} className="page-item active">
          <a
            className="page-link"
            href="#"
            onClick={handlePageItemClick(currentPage)}
          >
            {currentPage}
          </a>
        </li>
      );

      pageLinks.push(
        <li key={"ellipsis-1"} className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            ∙∙∙
          </a>
        </li>
      );

      for (let i = numPages - 1; i <= numPages; i++) {
        if (currentPage === i) {
          continue;
        }

        pageLinks.push(
          <li key={i} className="page-item">
            <a className="page-link" href="#" onClick={handlePageItemClick(i)}>
              {i}
            </a>
          </li>
        );
      }
    } else {
      pageLinks.push(
        <li key={1} className="page-item">
          <a className="page-link" href="#" onClick={handlePageItemClick(1)}>
            {1}
          </a>
        </li>
      );

      pageLinks.push(
        <li key={"ellipsis-1"} className="page-item">
          <a
            className="page-link"
            href="#"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            ∙∙∙
          </a>
        </li>
      );

      for (let i = numPages - 2; i <= numPages; i++) {
        pageLinks.push(
          <li
            key={i}
            className={`page-item ${currentPage === i ? "active" : ""}`}
          >
            <a className="page-link" href="#" onClick={handlePageItemClick(i)}>
              {i}
            </a>
          </li>
        );
      }
    }
  }

  return (
    <nav className="d-flex justify-content-center justify-content-md-end mt-5">
      <ul className="pagination pagination-sm text-gray-400">
        {currentPage !== 1 && (
          <li className="page-item">
            <a
              className="page-link page-link-arrow"
              href="#"
              onClick={handlePageItemClick(currentPage - 1)}
            >
              <i className="fa fa-caret-left"></i>
            </a>
          </li>
        )}

        {pageLinks}

        {currentPage !== numPages && (
          <li className="page-item">
            <a
              className="page-link page-link-arrow"
              href="#"
              onClick={handlePageItemClick(currentPage + 1)}
            >
              <i className="fa fa-caret-right"></i>
            </a>
          </li>
        )}
      </ul>
    </nav>
  );
});
